'use strict';

export default {
  paymentAccounts: {
    buttons: {
      edit: 'Edit',
      delete: 'Delete',
      addAccount: 'Add Payment Account',
      cancel: 'Cancel',
      save: 'Save',
      stripePortal: 'Go to Stripe account',
    },
    labels: {
      accounts: 'Payment Accounts',
      deleteAccount: 'Are you sure you want to delete this payment account ?',
      editModalTitle: 'Edit Payment Account',
      accountName: 'Account Name',
      editSuccess: 'Payment Account Successfully Updated',
      deleteSuccess: 'Payment Account Successfully Deleted',
      delete: 'Delete Account',
      editError: 'Payment Account Modifications Failed',
      deleteError: 'Payment Account Suppression Failed',
      noAccounts: 'No payment accounts on this organization',
    },
  },
};
